import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withSnackbar } from "notistack";
import LoadingOverlay from "components/common/loadingOverlay";
import mapStateToProps from "reducers/actions/stateToProps";
import mapDispatchToProps from "reducers/actions/dispatchProps";
import './layoutstyle.css';
import i18n from "i18n";

let path = window.location.pathname.toLowerCase();
class NavBar extends React.Component {
  state = {
    openOverlay: false,
    version:
      process && process.env && process.env.REACT_APP_VERSION
        ? process.env.REACT_APP_VERSION
        : "x.x.x",
  };

  render() {
    // let isTe = WebClientStore.Cookie.get('i18next') === "te";
    let isTe = i18n.language && i18n.language === "te";
    // console.debug('i18n.language', i18n.language);
    // console.debug('isTe', isTe)
    return (
      <div>
        <nav
          className="navbar navbar-expand-lg navbar-light theme-splash-background"
          style={{ minHeight: "100px", paddingTop: "32px" }}
        >
          <a href="/" className="navbar-brand" id="sidebar-logo-link">
            <img src="/android-chrome-192x192.png" className="nav-bar-brand-logo" alt="Chits Logo" />
            <span className="font-indie-flower-title">Chits</span>  
          </a>
          <button
            className="navbar-toggler"
            type="button"
            id="btnNavbarToggler"
            data-toggle="collapse"
            aria-controls="navbarToggler"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-bar burger-lines"></span>
            <span className="navbar-toggler-bar burger-lines"></span>
            <span className="navbar-toggler-bar burger-lines"></span>
          </button>
          <div className="collapse navbar-collapse justify-content-end" id="navbarToggler" >
            <ul className="navbar-nav">
              <li className="nav-item dropdown">
                <div className="dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    id="dropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Settings
                  </a>

                  <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <a className="dropdown-item" href="/profile">
                      My Profile
                    </a>
                    {/* <div className="dropdown-divider"></div> */}
                    <a className="dropdown-item" href="/logout">
                      Logout
                    </a>
                  </div>
                </div>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/contacts">Contacts</a>
              </li>
              <li className="nav-item">
                <div className="dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    id="dropdownLangLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Languages
                  </a>

                  <div className="dropdown-menu" aria-labelledby="dropdownLangLink">
                    <a className="dropdown-item" href="?lng=en">English</a>
                    <a className="dropdown-item" href="?lng=te">తెలుగు</a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        {this.state.openOverlay && <LoadingOverlay />}
      </div>
    );
  }
}

NavBar.propTypes = {
  sessionExpiry: PropTypes.string,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(NavBar));
